// components/Innovation/InnovationWrapper.tsx
import { useEffect } from "react";
import InnovationHero from "./InnovationHero";
import InnovationIntroCards from "./InnovationCards";
import InnovationOfferings from "./InnovationOfferings";
import InnovationNarration from "./InnovationNaration";
import InnovationBenefits from "./InnovationBenefits";
import ProductComparison from "./ProductComparison";

const InnovationWrapper: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="relative w-full overflow-hidden text-text-primary bg-white">

      {/* Medical textured background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-medical-texture opacity-[0.35]"
      />

      {/* Page container */}
      <div
        className="
          relative mx-auto max-w-[1440px]
          px-4 sm:px-6 lg:px-12
          pt-20 sm:pt-24 lg:pt-32
          pb-20 sm:pb-24 lg:pb-32
        "
      >
        {/* Controlled internal spacing */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          <InnovationHero />
          <InnovationIntroCards />
          <ProductComparison />
          <InnovationOfferings />
          <InnovationNarration />
          <InnovationBenefits />
        </div>
      </div>

    </main>
  );
};

export default InnovationWrapper;
